export default __webpack_public_path__ + "static/media/arabia-developments-logo.74684323.png";